import script from "./SoDramaList.vue?vue&type=script&setup=true&lang=js"
export * from "./SoDramaList.vue?vue&type=script&setup=true&lang=js"

import "./SoDramaList.vue?vue&type=style&index=0&id=cc8f5e72&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc8f5e72"]])

export default __exports__